import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { ArrayUtils } from 'record-it-utils/utils/ArrayUtils/ArrayUtils';
import { RoutePaths } from '../classes/RoutePaths/RoutePaths';
import { DefaultLayout } from '../components/layout/DefaultLayout/DefaultLayout';
import { LoginLayout } from '../components/layout/LoginLayout/LoginLayout';
import { useAuth } from '../hooks/useAuth';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { AppRouteElementWrapper } from './AppRouteElementWrapper';
import { AuthenticatedPermission, LayoutType, NavigationConfigurationPermissions, navigationConfigurations, NavigationConfigurationWithKey } from './navigationConfigurations';
export const AppRoutes: FunctionComponent<Record<string, never>> = React.memo(() => {
  const $ = _c(15);
  const {
    isLoggedIn
  } = useAuth();
  const {
    currentUser
  } = useCurrentUser();
  if (!currentUser && isLoggedIn) {
    return null;
  }
  let t0;
  if ($[0] !== isLoggedIn) {
    t0 = isLoggedIn ? RoutePaths.home() : RoutePaths.loginPage();
    $[0] = isLoggedIn;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const rootPath = t0;
  let T0;
  let T1;
  let t1;
  if ($[2] !== isLoggedIn) {
    const configsWithPermission = navigationConfigurations.filter(config => {
      switch (config.permissions.authenticated) {
        case AuthenticatedPermission.All:
          {
            return true;
          }
        case AuthenticatedPermission.OnlyUnauthenticated:
          {
            return !isLoggedIn;
          }
        case AuthenticatedPermission.OnlyAuthenticated:
          {
            if (!isLoggedIn) {
              return false;
            }
            return true;
          }
        default:
          {
            throw new Error(`branch for ${(config.permissions as NavigationConfigurationPermissions).authenticated} not implemented`);
          }
      }
    });
    const configsByLayout = ArrayUtils.group(configsWithPermission, _temp);
    const configGroups = Array.from(configsByLayout.entries()).map(_temp2);
    const getLayoutElement = _temp3;
    T1 = BrowserRouter;
    T0 = Routes;
    t1 = configGroups.map(group => <Route element={getLayoutElement(group.layoutType)} key={group.layoutType}>{group.configs.map(_temp4)}</Route>);
    $[2] = isLoggedIn;
    $[3] = T0;
    $[4] = T1;
    $[5] = t1;
  } else {
    T0 = $[3];
    T1 = $[4];
    t1 = $[5];
  }
  let t2;
  if ($[6] !== rootPath) {
    t2 = <Route path="*" element={<Navigate to={rootPath} replace={true} />} />;
    $[6] = rootPath;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== T0 || $[9] !== t1 || $[10] !== t2) {
    t3 = <T0>{t1}{t2}</T0>;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== T1 || $[13] !== t3) {
    t4 = <T1>{t3}</T1>;
    $[12] = T1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
});
function _temp(config_0) {
  return config_0.layoutType;
}
function _temp2(t0) {
  const [layoutType, configs] = t0;
  return {
    layoutType,
    configs
  };
}
function _temp3(layoutType_0) {
  switch (layoutType_0) {
    case LayoutType.Default:
      {
        return <DefaultLayout />;
      }
    case LayoutType.Login:
      {
        return <LoginLayout />;
      }
    default:
      {
        throw new Error(`unknown layoutType: ${layoutType_0}`);
      }
  }
}
function _temp4(config_1) {
  return <Route key={config_1.key} {...config_1.routeProps} element={<AppRouteElementWrapper config={config_1} />} />;
}